import React from "react";
import { BrowserRouter } from 'react-router-dom';
import Modal from "./components/Modal";
import MobileCard from "./components/MobileCard";
import { EAppKey } from "./type";
var App = function App(_ref) {
  var appKey = _ref.appKey,
    router = _ref.router;
  return /*#__PURE__*/React.createElement(BrowserRouter, null, appKey === EAppKey.MOBILE ? /*#__PURE__*/React.createElement(MobileCard, null) : /*#__PURE__*/React.createElement(Modal, {
    appKey: appKey,
    router: router
  }));
};
export default App;